var MurliModule = (function () {
    'use strict';
    var slideOutMenu = require('./slideoutmenu');
    var utils = require('./utils');
    var moment = require('moment');
    var avyaktMurliDates = [];
    var murliReady = false;
    var menuReady =false;
    var isMurliApp = navigator.userAgent.indexOf("MurliApp") !== -1;
    var isOffline = ('onLine' in navigator && !navigator.onLine) || (typeof navigator.connection != 'undefined' && navigator.connection.type === 'none');
    var globals = require('globals.js');

    function checkMurliExists(config, type, callback) {
        if (config.cat == "season") {
            callback(false);
            return;
        }
        var url = '';
        if (type == 'audio1')
            url = config.baseUrl + "/murlis/" + config.lang + "/mp3/murli-" + config.currentDate.format('YYYY-MM-DD') + ".mp3";
        else if (type == 'audio2')
            url = config.baseUrl + "/murlis/" + config.lang + "/mp3/murli-" + config.currentDate.format('YYYY-MM-DD') + "-" + ((config.lang == "hi") ? "osb" : "e2") + ".mp3";
        else if (type == 'essence')
            url = config.baseUrl + "/murlis/" + config.lang + "/mp3/murli-" + config.currentDate.format('YYYY-MM-DD') + "-" + 'ess' + ".mp3";
        else if (type == 'experiment')
            url = config.baseUrl + "/murlis/" + config.lang + "/mp3/me-" + config.currentDate.format('YYYY-MM-DD') + ".mp3";
        else if (type == 'song')
            url = config.baseUrl + "/murlis/hi/mp3/song-" + config.currentDate.format('YYYY-MM-DD') + ".mp3";
        else {
            callback(false);
            return;
        }
        //console.log('Checking murli on url: ' + url);
        //else if (type == 'latest')
        //    url = "/murlis/" + config.lang + "/mp3/latest.mp3";
        //console.log('Checking file: ' + url);
        fetch(url, {
            method: 'HEAD'
        }).then(function (response) {
            callback(response.ok);
        }).catch(function (err) {
			if (isOffline) {
				console.log('App is offline checking cache for file: ' + globals.cache.toPath(url));
				var existsInCache = globals.fs.exists(globals.cache.toPath(url));
				console.log('Exists in cache is ' + !(existsInCache == false));
			    callback(!(existsInCache == false));
			}
			else {
				console.log("No murli found or isOffline");
			    callback(false);
			}
        });
    }

    function loadMurli(config) {
        var murliContainer = $("#murli-container");
        murliContainer.html('<p class="feedback-msg">Please have a moment of remembrance whilst the murli is loading....</p>');
        var url = config.baseUrl + "/murlis/" + config.lang + "/html/murli-" + config.currentDate.format('YYYY-MM-DD') + ".html";
        if (config.cat == "season")
            url = config.baseUrl + "/murlis/" + config.lang + "/html/murli-" + config.currentDate.format('YYYY-MM-DD') + "-season.html";

        fetch(url).then(function (response) {
            if (response.ok) {
            	return response.text();
            }
            return '<p class="feedback-msg">The requested murli does not seem to be available at the moment.<br>Please try again later.</p>';
        }).then(function (body) {
            globals.fs.write(globals.cache.toPath(url), body);
            murliContainer.html(body);
            murliContainer.trigger('murliready', config);
        }).catch(function (err) {  
            console.log('Trying to read murli from cache. File: ' + globals.cache.toPath(url));

			globals.fs.exists(globals.cache.toPath(url)).then(function(entry) {
				globals.fs.read(globals.cache.toPath(url)).then(function(content) {
					murliContainer.html(content);
					murliContainer.trigger('murliready', config);
				}).catch(function(err) {
					console.error('An error occurred reading murli from cache. Error: ', err);
				});
			}).catch(function(err) {
				console.error('File does not exist: ' + globals.cache.toPath(url));
				if (isOffline)
					murliContainer.html('<p class="feedback-msg">You&#39;re currently offline, so I could not retrieve the requested murli.<br>Please try again when you&#39;re online.</p>');
				else
					murliContainer.html('<p class="feedback-msg">The requested murli does not seem to be available at the moment.<br>Please try again later.</p>');
				murliContainer.trigger('murliready', config);
			});
        });
    };

    function moveToDate(config, d) {
        //console.log('Moving to date: ' + ((d) ? d.format() : config.currentDate.format()) + ', ' + config);
        murliReady = false;
        $("#murli-container").html("Have a moment of remembrance whilst I'm loading the murli.");
        if (d) {
            config.currentDate = d;
            if (config.cat == 'season') {
                var pos = avyaktMurliDates.indexOf(d.format('YYYY-MM-DD'));
                if (pos > 0 && pos < avyaktMurliDates.length - 1) {
                    config.previousDate = moment(avyaktMurliDates[pos - 1]);
                    config.nextDate = moment(avyaktMurliDates[pos + 1]);
                }
                else if (pos < 1) {
                    config.previousDate = moment('1900-01-01');
                    config.nextDate = moment(avyaktMurliDates[pos + 1]);
                }
                else if (pos > avyaktMurliDates.length - 1) {
                    config.nextDate = moment('2099-12-31');
                    config.previousDate = moment(avyaktMurliDates[pos - 1]);
            }
        }
        else {
            config.previousDate = moment(d).subtract(1, 'days');
            config.nextDate = moment(d).add(1, 'days');
        }
    }
    loadMurli(config);
}


    // onSuccess Callback
    // This method accepts a JSON object, which contains the
    // message response
    var onFileOpenSuccess = function(data) {
        console.log('File successfully opened. ' + data.message);
    };

    // onError Callback receives a json object
    function onFileOpenError(error) {
        alert('Error message: ' + error.message);
    }
    function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    function downloadFile(url, filename){
        if (device.platform == "Android") {
            //storageLocation = cordova.file.externalApplicationStorageDirectory;
            var mimeType = 'audio/mpeg';
            if (endsWith(filename, 'pdf')) {
                mimeType = 'application/pdf';
            }
            var fail = function (message) {    
                alert(message);
            };
            var success = function (data) {
                console.log("Succes downloading " + filename);
            };
            cordova.plugins.DownloadManager.download(url, null, filename, mimeType, null, success, fail);
        }
        else {
            // ==================================================
            // # iOS
            // ==================================================
            var storageLocation = cordova.file.dataDirectory;
            requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (fs) {
                console.log("StorageLocation = " + storageLocation);
                resolveLocalFileSystemURL(storageLocation + 'Download/' + filename, function (fileEntry) { 
                    console.log("File " + fileEntry.fullPath + " exists!");
                    //cordova.plugins.FileOpener.openFile(fileEntry.toURL(), onFileOpenSuccess, onFileOpenError);
                    cordova.plugins.fileOpener2.open(fileEntry.toURL(), null, {
                        success: onFileOpenSuccess,
                        error: onFileOpenError
                    });
                },
                function() {
                    resolveLocalFileSystemURL(storageLocation, 
                        function(fileSystem) {
                            fileSystem.getDirectory('Download', {
                                create: true,
                                exclusive: false
                            },
                            function(dir) {
                                dir.getFile(filename, {create:true}, function(file) {
                                    ProgressIndicator.showSimpleWithLabel(false, 'Downloading...');
                                    var req = new XMLHttpRequest();
                                    console.log('Downloading file: ' + url);
                                    req.open("GET", url, true);
                                    req.responseType = "blob";
                                    req.onload = function (oEvent) {
                                        var blob = req.response;
                                        if (blob) { 
                                            file.createWriter(function (writer) {
                                                writer.onwriteend = function (evt) {
                                                    console.log("File written successfully.");
                                                    ProgressIndicator.hide();
                                                    cordova.plugins.fileOpener2.open(
                                                        file.toURL(),
                                                        null,
                                                        {
                                                            success: onFileOpenSuccess,
                                                            error: onFileOpenError
                                                                    });
                                                                };
                                                                writer.write(blob);
                                                            }, function (error) {
                                                                ProgressIndicator.hide();
                                                console.log("Failed to write file.");
                                                alert('Error message: ' + error.message);
                                            });
                                        } else {
                                            ProgressIndicator.hide();
                                            console.error('Did not receive a XHR response for: ' + url);
                                            alert('Error message: Failed to download file. Please try again later.');
                                        }
                                    };
                                    req.send(null);
                                } ,errorCallback1);
                            } ,errorCallback2);
                        }, errorCallback3
                    );
                    console.log('File download complete');                
                });
            }, getFSFail); //of requestFileSystem
        }
    }

    var errorCallback1 = function(e) {
        console.log('1' + JSON.stringify(e, null, 4));
    }
    var errorCallback2 = function(e) {
        console.log('2' + JSON.stringify(e, null, 4));
    }
    var errorCallback3 = function(e) {
        console.log('3' + JSON.stringify(e, null, 4));
    }

    function getFSFail(evt) {
        console.log(evt.target.error.code);
    }

    var langSwitchCtl = function() {
        var conf;
        
        var _private = {
            bind: function () { 
                $("#lang-switch").unbind().change(function () {
                    conf.lang = $(this).val();
                    conf.cat = "daily";
                    slideOutMenu.init(conf);
                    moveToDate(conf);
                    //init(conf);
                    localStorage.setItem("murli.lang", conf.lang);
                    window.gaU('send', 'event', { 'eventCategory': 'Language', 'eventAction': 'selection', 'eventLabel': conf.lang });
                });
            }
        };
        
        return {
            init: function (config) {
                conf = config;
                _private.bind();
            }
        };
    }();

    var navCtls = function () {
        var conf;
        
        var _private = {
            bind: function () { 
                $("#back-btn").unbind().click(function () {
                    //conf.cat = 'daily';
                    moveToDate(conf, conf.previousDate);
                    window.gaU('send', 'event', { 'eventCategory': 'Navigation', 'eventAction': 'click', 'eventLabel': 'Navigate back ' + conf.lang });
                });
                $("#forward-btn").unbind().click(function () {
                    //conf.cat = 'daily';
                    moveToDate(conf, conf.nextDate);
                    window.gaU('send', 'event', { 'eventCategory': 'Navigation', 'eventAction': 'click', 'eventLabel': 'Navigate forward ' + conf.lang });
                });
            }
        };
      
        return {
            init: function (config) {
                conf = config;
                if (conf.cat == 'season') {
                    $('#previous-day').html("Prev");
                    $('#previous-day-suffix').html("");
                    $('#next-day').html("Next");
                    $('#next-day-suffix').html("");
                }
                else {
                    $('#previous-day').html(conf.previousDate.date());
                    $('#previous-day-suffix').html(utils.ordinalSuffixOf(conf.previousDate.date()));
                    $('#next-day').html(conf.nextDate.date());
                    $('#next-day-suffix').html(utils.ordinalSuffixOf(conf.nextDate.date()));
                    if (conf.today.clone().add(3, 'days').isAfter(conf.nextDate))
                        $('#forward-btn').prop('disabled', false).removeClass('disabled');
                    else
                        $('#forward-btn').prop('disabled', true).addClass('disabled');
                }                
                _private.bind();
            }
        };
    }();

    var downloadCtls = new function () {
        var conf;
        var windowWidth;
        
        var _private = {
            bind: function () {
                $('#download-btn').unbind().removeAttr('href').addClass('btn-dropdown').click(function () {
                    $('#downloadList').toggle();
                });

                $(document).on('click', function (event) {
                    if (!$(event.target).closest('#downloadList').length && !$(event.target).closest('#download-btn').length) {
                        $('#downloadList').hide();
                    }
                    if (!$(event.target).closest('#audioList').length && !$(event.target).closest('#audio-btn').length) {
                        $('#audioList').hide();
                    }
                });

                $('#audio-btn').unbind().click(function () {
                    $('#audioList').toggle();
                });

                $("#audioListItem1").click(function () {
                    _private.setAudio('audio1', true);
                    $('#audioList').hide();
                });

                $("#audioListItem2").click(function () {
                    _private.setAudio('audio2', true);
                    $('#audioList').hide();
                });

                $("#audioListItem3").click(function () {
                    _private.setAudio('essence', true);
                    $('#audioList').hide();
                });

                $("#audioListItem4").click(function () {
                    _private.setAudio('experiment', true);
                    $('#audioList').hide();
                });

            },
            setAudio: function (audioType, play) {
                $("#player1")[0].pause();
                var ext = "";
                if (audioType == "essence")
                    ext = "-ess";
                if (audioType == "audio2" && conf.lang == "hi")
                    ext = "-osb";
                if (audioType == "audio2" && conf.lang == "en")
                    ext = "-e2";
                if (audioType == "experiment")
                    $("#player1")[0].setSrc(conf.baseUrl + "/murlis/" + conf.lang + "/mp3/me-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3");
                else
                    $("#player1")[0].setSrc(conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + ext + ".mp3");
                localStorage.setItem("murli.audioType", audioType);
                if (play) {
                    $("#player1")[0].play();
                }
            },
            renderAudioBtn: function () {
                var audios = $("#audioList li.menuItem").filter(function () {
                    return this.style.display != 'none';
                });
                if (audios.length > 1) {
                    $('#audio-btn').show();
                }
                else if (audios.length == 1 && $(window).width() < 992) {
                    $('#audio-btn').show();
                    $('#audioListItem0').show();
                }
                else
                    $('#audio-btn').hide();
                return audios.length;
            },
            renderPlayer: function (width) {
                var audioType = localStorage.getItem('murli.audioType');
                if (typeof audioType === 'undefined' || audioType === null) {
                    audioType = 'audio1';
                }
                var audioSrc = conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3";
                if ((conf.lang == "hi" || conf.lang == "en") && audioType == "audio2") {
                    audioSrc = conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + "-" + ((conf.lang == "hi") ? "osb" : "e2") + ".mp3";
                }
                $('#audioListItem0').empty();
                $('#audio-container').empty();
                if (width < 992) {
                    $('#audioListItem0').append('<audio id="player1" class="audioplayer" src="' + audioSrc + '" type="audio/mp3" controls preload="metadata"></audio>');
                    $('#player1').mediaelementplayer({
                        autosizeProgress: true,
                        enableAutosize: true,
                        defaultAudioWidth: $('#object').width($('#object').parent().width() - 24),
                        stretching: 'fill',
                        features: ['playpause', 'progress', 'current', 'duration'],
                        timeAndDurationSeparator: '<span>/</span>',
                        success: function (me) {
                            me.addEventListener('play', function (e) {
                            	console.log('Play event fired for: ' + audioSrc);
                                window.gaU('send', 'event', { 'eventCategory': 'Audio', 'eventAction': 'play', 'eventLabel': 'Playing ' + audioType + " " + conf.lang + " " + conf.cat });
                            }, false);
                            me.addEventListener('pause', function (e) {
                            	console.log('Pause event fired for: ' + audioSrc);
                                window.gaU('send', 'event', { 'eventCategory': 'Audio', 'eventAction': 'play', 'eventLabel': 'Pausing ' + audioType + ' ' + conf.lang + ' ' + conf.cat });
                            }, false);
                        }
                    });
                    $(".mejs__time-rail").width("130px");
                }
                else {
                    $('#audio-container').append('<audio id="player1" class="audioplayer" src="' + audioSrc + '" type="audio/mp3" controls preload="metadata"></audio>');
                    $('#player1').mediaelementplayer({
                        features: ['playpause', 'progress', 'current', 'duration'],
                        timeAndDurationSeparator: '<span> / </span>',
                        defaultAudioWidth: $('#audio-container').width(),
                        stretching: 'fill',
                        success: function (me) {
                            me.addEventListener('play', function (e) {
                            	console.log('Play event fired for: ' + audioSrc);
                                window.gaU('send', 'event', { 'eventCategory': 'Audio', 'eventAction': 'play', 'eventLabel': 'Playing ' + audioType + ' ' + conf.lang + ' ' + conf.cat });
                            }, false);
                            me.addEventListener('pause', function (e) {
                            	console.log('Pause event fired for: ' + audioSrc);
                                window.gaU('send', 'event', { 'eventCategory': 'Audio', 'eventAction': 'play', 'eventLabel': 'Pausing ' + audioType + ' ' + conf.lang + ' ' + conf.cat });
                            }, false);
                        }
                    });
                }

            }
        };
        return {
            init: function (config) {
                conf = config;
                windowWidth = $(window).width();

                var pdfFilename = "murli-" + conf.currentDate.format('YYYY-MM-DD') + ".pdf";
                $("#murli-type>span").text("Daily Murli");
                if (config.cat == "season") {
                    pdfFilename = "murli-" + conf.currentDate.format('YYYY-MM-DD') + "-season.pdf";
                    $("#murli-type>span").text("Avyakt Murli");
                }
                $("#download-btn").unbind().removeClass("btn-dropdown").attr("href", conf.baseUrl + "/murlis/" + conf.lang + "/pdf/" + pdfFilename).attr("download", pdfFilename);
                if (isMurliApp) {
                    $("#downloadPdf").attr("download", pdfFilename).unbind().click(function(event) {
                        downloadFile(conf.baseUrl + "/murlis/" + conf.lang + "/pdf/" + pdfFilename, pdfFilename);
                        $('#downloadList').hide();
                    });
                }
                else
                    $("#downloadPdf").attr("href", conf.baseUrl + "/murlis/" + conf.lang + "/pdf/" + pdfFilename).attr("download", pdfFilename);
                $("#downloadListItem1").hide();
                $("#downloadListItem2").hide();
                $("#downloadListItem3").hide();
                $("#downloadListItem4").hide();

                $("#audio-btn").hide();
                $("#audioListItem0").hide();
                $("#audioListItem1").hide();
                $("#audioListItem2").hide();
                $("#audioListItem3").hide();
                $("#audioListItem4").hide();

                if (conf.cat !== "season")
                    _private.renderPlayer($(window).width());
                
                $(".mejs__container").hide();

                checkMurliExists(conf, 'audio1', function (exists) {
                    if (exists) {
                        
                        if (isMurliApp) {
                            $("#downloadAudio1").attr("download", "audio-murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3").unbind().click(function(event) {
                                downloadFile(conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3", "murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3");
                                $('#downloadList').hide();
                            });
                        }
                        else
                            $("#downloadAudio1").attr("href", "#").attr("onclick", "window.open('" + conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3', '_system');").attr("download", "audio-murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3");

                        $("#downloadListItem1").show();
                        $("#audio-btn").show();
                        $("#audioListItem1").text('Play ' + $("#lang-switch option:selected").text() + ' Murli');
                        $("#audioListItem1").show();
                        _private.renderAudioBtn();

                        $(".mejs__container").show();

                        _private.bind();
                    }
                    else {
                    	if (localStorage.getItem('murli.audioType') === 'audio1')
                    		localStorage.removeItem('murli.audioType');
                    }
                });
                checkMurliExists(conf, 'audio2', function (exists) {
                    if (exists) {
                        if (isMurliApp) {
                            $("#downloadAudio2").attr("download", "audio-murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + "-" + ((conf.lang == "hi") ? "osb" : "e2") + ".mp3").unbind().click(function(event) {
                                downloadFile(conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + "-" + ((conf.lang == "hi") ? "osb" : "e2") + ".mp3", "murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + "-" + ((conf.lang == "hi") ? "osb" : "e2") + ".mp3");
                                $('#downloadList').hide();
                            });
                        }
                        else
                            $("#downloadAudio2").attr("href", "#").attr("onclick", "window.open('" + conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + "-" + ((conf.lang=="hi")?"osb":"e2") + ".mp3', '_system');").attr("download", "audio-murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + "-" + ((conf.lang=="hi")?"osb":"e2") + ".mp3");
                        $("#downloadListItem2 span.downloadTxt").text((conf.lang == "en") ? "English 2" : "Hindi (Madhuban)");
                        $("#downloadListItem2").show();

                        $("#audio-btn").show();
                        $("#audioListItem2").text(((conf.lang === "hi") ? "Play Hindi Murli (Madhuban)" : "Play English 2 Murli")).show();
                        $("#audioListItem2").show();
                        _private.renderAudioBtn()

                        $(".mejs__container").show();

                        _private.bind();
                    }
                    else {
                    	if (localStorage.getItem('murli.audioType') === 'audio2')
                    		localStorage.removeItem('murli.audioType');
                    }
                });
                checkMurliExists(conf, 'essence', function (exists) {
                    if (exists) {
                        if (isMurliApp) {
                            $("#downloadAudio3").attr("download", "audio-murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + "-ess.mp3").unbind().click(function(event) {
                                downloadFile(conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + "-ess.mp3", "murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + "-ess.mp3");
                                $('#downloadList').hide();
                            });
                        }
                        else 
                            $("#downloadAudio3").attr("href", "#").attr("onclick", "window.open('" + conf.baseUrl + "/murlis/" + conf.lang + "/mp3/murli-" + conf.currentDate.format('YYYY-MM-DD') + "-ess.mp3', '_system');").attr("download", "murli-essence-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3");
                        $("#downloadListItem3").show();
                        $("#audio-btn").show();
                        $("#audioListItem3").show();
                        _private.renderAudioBtn();
                        $(".mejs__container").show();
                        _private.bind();
                    }
                    else {
                    	if (localStorage.getItem('murli.audioType') === 'essence')
                    		localStorage.removeItem('murli.audioType');
                    }
                });
                checkMurliExists(conf, 'experiment', function (exists) {
                    if (exists) {
                        if (isMurliApp) {
                            $("#downloadAudio4").attr("download", "audio-murli-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + "-me.mp3").unbind().click(function(event) {
                                downloadFile(conf.baseUrl + "/murlis/" + conf.lang + "/mp3/me-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3", "murli-experiment-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3");
                                $('#downloadList').hide();
                            });
                        }
                        else 
                            $("#downloadAudio4").attr("href", conf.baseUrl + "/murlis/" + conf.lang + "/mp3/me-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3").attr("download", "murli-experiment-" + conf.lang + "-" + conf.currentDate.format('YYYY-MM-DD') + ".mp3");
                        $("#downloadListItem4").show();
                        $("#audio-btn").show();
                        $("#audioListItem4").show();
                        _private.renderAudioBtn();
                        $(".mejs__container").show();
                        _private.bind();
                    }
                    else {
                    	if (localStorage.getItem('murli.audioType') === 'experiment')
                    		localStorage.removeItem('murli.audioType');
                    }
                });
            }
        };
    }();

    function initAudioCtls(config) {
        $("#player1")[0].pause();
        $(".mejs__button.mejs__playpause-button").removeClass("mejs__pause").addClass("mejs__play");
        $(".mejs__container").hide();
        $("#audioList").hide();
    };

    function initControls(config) {
        langSwitchCtl.init(config);
        navCtls.init(config);
        downloadCtls.init(config);
        //initAudioCtls(config);
        $("#print-btn").click(function () {
            window.print();
            window.gaU('send', 'event', { 'eventCategory': 'Print', 'eventAction': 'click', 'eventLabel': 'Printed ' + config.lang + ' ' + config.cat });
        });
    };

    function initSong(config) {
        if ($(".song-txt").length) {
            checkMurliExists(config, 'song', function (exists) {
                if (exists) {
                    $(".song-txt").append(' <audio id="song-player" class="audioplayer" src="' + config.baseUrl + '/murlis/hi/mp3/song-' + config.currentDate.format('YYYY-MM-DD') + '.mp3" type="audio/mp3" controls preload="metadata"></audio>');
                    $("#song-player").mediaelementplayer({
                        defaultAudioWidth: 80,
                        audioHeight: 24,
                        enableAutosize: false,
                        features: ['playpause'],
                        success: function (me) {
                            me.addEventListener('play', function (e) {
                                console.log('Play event fired for song.');
                                window.gaU('send', 'event', { 'eventCategory': 'Audio', 'eventAction': 'play', 'eventLabel': 'Playing song ' + config.lang + ' ' + config.cat });
                            }, false);
                            me.addEventListener('pause', function (e) {
                                console.log('Pause event fired for song.');
                                window.gaU('send', 'event', { 'eventCategory': 'Audio', 'eventAction': 'play', 'eventLabel': 'Pausing song ' + config.lang + ' ' + config.cat });
                            }, false);
                        }
                    });
                }
            });
        }
    }

    function onAvyaktListReady(event, config, avyaktMurliDates1) {
        menuReady = true;
        avyaktMurliDates = avyaktMurliDates1;
        //if (menuReady && murliReady) {
        //    initControls(config);
        //}
    };

    function onMurliReady(event, config) {
        murliReady = true;
        //if (menuReady && murliReady) {
            initControls(config);
        //}
        $("#lang-switch").val(config.lang);
        initSong(config);
        window.gaU('send', 'pageview', { 'title': 'Official Brahma Kumaris Daily Murli', 'page': '/' + config.cat + '-' + config.lang + '-' + config.currentDate.format('YYYY-MM-DD') });
        //window.history.pushState({ href: "/#" + config.lang + "+" + config.currentDate.format("YYYY-MM-DD") }, "Official Brahma Kumaris Daily Murli", "/#" + config.lang + "+" + config.currentDate.format("YYYY-MM-DD") + "+" + config.cat);
    };

    // main init method
    function init(config) {
        console.log('Initialising murli module .....');

        $(".slideout-menu").on('avyaktlistready', function (event, config, avyaktMurliDates) {
            onAvyaktListReady(event, config, avyaktMurliDates);
        });
        slideOutMenu.init(config);

        $("#murli-container").on('murliready', function (event, config) {
            onMurliReady(event, config);
        });
        moveToDate(config);
    }

    return {
        init: init,
        downloadFile: downloadFile,
        moveToDate: moveToDate
    };
}());

module.exports = MurliModule;
